import { CommonLocalStorageKeyEnum } from 'Feature/Common/Common/Types/Enums/CommonLocalStorageKeyEnum';
import { Storage } from 'Shared/Utils/LocalStorage/Storage';

import { IMenuCategory } from '../models/IMenuCategory';

export default class MenuCategories extends Storage<CommonLocalStorageKeyEnum, IMenuCategory> {
  private static instance?: MenuCategories;

  private constructor() {
    super();
  }

  public static getInstance() {
    if (!this.instance) {
      this.instance = new MenuCategories();
    }

    return this.instance;
  }

  public getMenuCategories(): IMenuCategory[] {
    const result = this.get(CommonLocalStorageKeyEnum.MENU_CATEGORIES);
    if (Array.isArray(result)) return result;
    else return [];
  }

  public getMenuCategoriesWithExpiry(): IMenuCategory[] {
    const result = this.getWithExpire(CommonLocalStorageKeyEnum.MENU_CATEGORIES);
    if (Array.isArray(result)) return result;
    else return [];
  }

  public setMenuCategories(modules: IMenuCategory[]): void {
    this.set(CommonLocalStorageKeyEnum.MENU_CATEGORIES, modules);
  }

  public setMenuCategoriesWithExpiry(modules: IMenuCategory[], expiry: Date): void {
    this.setWithExpire(CommonLocalStorageKeyEnum.MENU_CATEGORIES, modules, expiry);
  }

  public clear(): void {
    this.clearItems([CommonLocalStorageKeyEnum.MENU_CATEGORIES]);
  }

  public modulesHasValue(): boolean {
    return this.hasValue(CommonLocalStorageKeyEnum.MENU_CATEGORIES);
  }

  public modulesIsExpire(): boolean {
    const isExpire = this.isExpire(CommonLocalStorageKeyEnum.MENU_CATEGORIES);
    if (isExpire) this.clear();
    return isExpire;
  }
}
